import { Role } from 'auth';
import { Navigate, useSearchParams } from 'react-router-dom';
import { commonPaths } from '@/modules/common/routes.tsx';
import { adminDashboardPaths } from '@/modules/admin-dashboard/routes.tsx';
import { entityPaths } from '@/modules/entity/routes.tsx';
import { issuerDashboardPaths } from '@/modules/issuer-dashboard/routes.tsx';

export interface GetUserDefaultRouteProps {
  role: Role;
}

export const GetUserDefaultRoute = ({ role }: GetUserDefaultRouteProps) => {
  const [params] = useSearchParams();
  if (role === Role.SR_INVESTOR) {
    return <Navigate to={{ pathname: entityPaths.static.entityList, search: params.toString() }} />;
  }
  if (role === Role.SR_ISSUER) {
    return (
      <Navigate
        to={{ pathname: issuerDashboardPaths.static.dashboard, search: params.toString() }}
      />
    );
  }
  if (role === Role.SR_ADMIN) {
    return (
      <Navigate to={{ pathname: adminDashboardPaths.static.issuers, search: params.toString() }} />
    );
  }

  return <Navigate to={commonPaths.static.notFound} />;
};
